export const ENTRY_DATA_SECTION_KEYS = {
  clinicalTrial: "Clinical Trials",
  clinicalTrialStatus: "Clinical Trial Status",
  regulatory: "Regulatory",
  deals: "Deals",
  expeditedProgram: "Expedited Program",
  ventureCapital: "Venture Capital",
  publication: "Publication",
  publicationJournal: "Publication Journal",
  conferenceSchedule: "Conference Schedule",
  dealFiling: "Deal Filing",
  fundingFiling: "Funding Filing",
  ctg: "CTG",
} as const;
